export const page: string[] = ['organization', 'user', 'site'];
